export const ADD_PAYMENT_FEE = 'ADD_PAYMENT_FEE';
export const ADD_PRODUCT_TO_CART_REQUEST = 'ADD_PRODUCT_TO_CART_REQUEST';
export const ADD_PRODUCT_TO_CART_SUCCESS = 'ADD_PRODUCT_TO_CART_SUCCESS';
export const ADD_PRODUCT_TO_CART_FAILURE = 'ADD_PRODUCT_TO_CART_FAILURE';
export const ADD_PRODUCT_TO_EXTERNAL_CART_REQUEST = 'ADD_PRODUCT_TO_EXTERNAL_CART_REQUEST';
export const ADD_PRODUCT_TO_EXTERNAL_CART_SUCCESS = 'ADD_PRODUCT_TO_EXTERNAL_CART_SUCCESS';
export const ADD_PRODUCT_TO_EXTERNAL_CART_FAILURE = 'ADD_PRODUCT_TO_EXTERNAL_CART_FAILURE';
export const GET_CART_REQUEST = 'GET_CART_REQUEST';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
export const GET_CART_FAILURE = 'GET_CART_FAILURE';
export const GET_EXTERNAL_CART_SUCCESS = 'GET_EXTERNAL_CART_SUCCESS';
export const GET_EXTERNAL_CART_FAILURE = 'GET_EXTERNAL_CART_FAILURE';
export const CLOSE_CART_MODAL = 'CLOSE_CART_MODAL';
export const CHANGE_SHIPPING_METHOD_REQUEST = 'CHANGE_SHIPPING_METHOD_REQUEST';
export const CHANGE_SHIPPING_METHOD_SUCCESS = 'CHANGE_SHIPPING_METHOD_SUCCESS';
export const CHANGE_SHIPPING_METHOD_FAILURE = 'CHANGE_SHIPPING_METHOD_FAILURE';
export const SET_CART_HYPERDRIVE_ENDPOINT = 'SET_CART_HYPERDRIVE_ENDPOINT';
export const CHANGE_ITEM_QUANTITY_REQUEST = 'CHANGE_ITEM_QUANTITY_REQUEST';
export const CHANGE_ITEM_QUANTITY_SUCCESS = 'CHANGE_ITEM_QUANTITY_SUCCESS';
export const CHANGE_ITEM_QUANTITY_FAILURE = 'CHANGE_ITEM_QUANTITY_FAILURE';
export const GET_SHIPPING_METHODS_SUCCESS = 'GET_SHIPPING_METHODS_SUCCESS';
export const SET_DELETING_PRODUCT = 'SET_DELETING_PRODUCT';
export const SET_CART_LABELS = 'SET_CART_LABELS';
export const VALIDATE_STOCK_REQUEST = 'VALIDATE_STOCK_REQUEST';
export const VALIDATE_STOCK_SUCCESS = 'VALIDATE_STOCK_SUCCESS';
export const VALIDATE_STOCK_FAILURE = 'VALIDATE_STOCK_FAILURE';
export const SET_VALIDATION_STOCK_STATUS = 'SET_VALIDATION_STOCK_STATUS';
export const SET_INITIAL_CART_STATE = 'SET_INITIAL_CART_STATE';
export const UPDATE_DISCOUNT_CODE_REQUEST = 'UPDATE_DISCOUNT_CODE_REQUEST';
export const UPDATE_DISCOUNT_CODE_SUCCESS = 'UPDATE_DISCOUNT_CODE_SUCCESS';
export const UPDATE_DISCOUNT_CODE_FAILURE = 'UPDATE_DISCOUNT_CODE_FAILURE';
export const SET_CART_ERROR_DATA = 'SET_CART_ERROR_DATA';
export const SET_IS_LOADING_CART = 'SET_IS_LOADING_CART';
export const SET_CART_QR_ID = 'SET_CART_QR_ID';
export const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
export const UPDATE_STOCK_QUANTITY_PRODUCT = 'UPDATE_STOCK_QUANTITY_PRODUCT';
export const SET_CART_STATE = 'SET_CART_STATE';
export const DELETING_CART_ITEMS = 'DELETING_CART_ITEMS';
